import React from 'react'
import MagicForHire from './components/MagicForHire'

const Spirit = () => {
  return (
    <div>
        <MagicForHire />
    </div>
  )
}

export default Spirit